export default {
  state: {
    data: false,
  },
  getters: {
    //
  },
  actions: {
    resetEvent(context) {
      context.commit("updateEvent", false)
    },
  },
  mutations: {
    updateEvent(state, data) {
      return state.data = data
    }
  }
}